
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-br from-purple-400 via-purple-500 to-purple-600 text-white overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 className="text-xl sm:text-2xl font-serif font-bold mb-6 sm:mb-10">
              おかやまペット葬儀株式会社
            </h3>
            <p className="text-sm leading-relaxed opacity-90">
              大切な家族との最後の時間を、心を込めてサポートします。岡山市で20年以上の実績と信頼。
            </p>
          </div>

          {/* Site Map */}
          <div>
            <h4 className="text-lg font-bold mb-4 sm:mb-5">サイトマップ</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-sm hover:text-pink-200 transition-colors inline-block"
                >
                  HOME
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm hover:text-pink-200 transition-colors inline-block"
                >
                  当院について
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-sm hover:text-pink-200 transition-colors inline-block"
                >
                  ペット葬について
                </Link>
              </li>
              <li>
                <Link
                  to="/company"
                  className="text-sm hover:text-pink-200 transition-colors inline-block"
                >
                  会社概要
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-sm hover:text-pink-200 transition-colors inline-block"
                >
                  料金表
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm hover:text-pink-200 transition-colors inline-block"
                >
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-lg font-bold mb-4 sm:mb-5">営業時間・アクセス</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <i className="ri-time-line mr-2 mt-0.5 flex-shrink-0"></i>
                <span>9:00 〜 18:00</span>
              </li>
              <li className="flex items-start">
                <i className="ri-calendar-line mr-2 mt-0.5 flex-shrink-0"></i>
                <span>定休日:日曜日・祝日</span>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-0.5 flex-shrink-0"></i>
                <span>岡山市北区○○町1-2-3</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4 sm:mb-5">お問い合わせ</h4>
            <p className="text-xs mb-3 opacity-90">24時間以内にご返信いたします</p>
            <div className="mb-4">
              <a
                href="tel:086-012-3456"
                className="text-xl font-bold hover:text-pink-200 transition-colors inline-flex items-center"
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center bg-white text-purple-600 px-6 py-3 rounded-full text-sm font-medium hover:bg-pink-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              メールでお問い合わせ
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/20 text-center">
          <p className="text-sm opacity-80">
            © {currentYear} おかやまペット葬儀株式会社 All Rights Reserved.
          </p>
          <div className="mt-4">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs opacity-70 hover:opacity-100 transition-opacity"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
